<template>
    <Toast position="bottom-right" />
    <router-view />
</template>

<script setup>
import Toast from "primevue/toast";
import { provide, onMounted, onUnmounted } from "vue";
import { db } from "../firebase/config.js";
import { collection, onSnapshot } from "firebase/firestore";
import { useNetworkStatus } from "../composables/useNetworkStatus.js";

const networkStatus = useNetworkStatus();
provide("networkStatus", networkStatus);

let unsubExams = null;
let unsubPatients = null;

onMounted(() => {
    const examsRef = collection(db, "exams");
    const patientsRef = collection(db, "patients");
    
    // monitor both collections for pending writes
    unsubExams = onSnapshot(examsRef, { includeMetadataChanges: true }, (snapshot) => {
        networkStatus.setPendingWrites(snapshot.metadata.hasPendingWrites);
    });
    
    unsubPatients = onSnapshot(patientsRef, { includeMetadataChanges: true }, (snapshot) => {
        networkStatus.setPendingWrites(snapshot.metadata.hasPendingWrites);
    });
});

onUnmounted(() => {
    if (unsubExams) unsubExams();
    if (unsubPatients) unsubPatients();
});
</script>
